export default "__VITE_ASSET__ps04ujac__"